import PropTypes from 'prop-types';
import './LoadingSpinner.css';

/**
 * LoadingSpinner Component
 * 
 * A loading spinner with optional text.
 * 
 * @param {string} size - Spinner size: 'sm', 'md', 'lg'
 * @param {string} text - Optional loading text
 * @param {boolean} fullScreen - Show as full screen overlay
 */
export default function LoadingSpinner({
  size = 'md',
  text,
  fullScreen = false
}) {
  const spinner = (
    <div className={`loading-spinner-container ${fullScreen ? 'loading-spinner-fullscreen' : ''}`}>
      <div className={`loading-spinner loading-spinner-${size}`}></div>
      {text && <p className="loading-text">{text}</p>}
    </div>
  );

  return spinner;
}

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  text: PropTypes.string,
  fullScreen: PropTypes.bool
};
